import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Page Sections
import FormInfomation from "pages/LandingPages/FormRegister/sections/FormInfomation";

// Routes
import routes from "routes";

function FormRegister() {
  const navigate = useNavigate();
  const location = useLocation();
  const props = location.state;
  useEffect(() => {
    if (props === null) {
      navigate("/ndrs-gsb-register/consent");
    }
  }, []);

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://ln15.gsb.or.th/ndrs",
          label: "GSB NDRS Website",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="45vh"
        width="100%"
        bgColor="#1e88e5"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h2"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              การลงทะเบียนเข้าร่วมมาตรการ
              <br />
              ผ่อนปรนเงื่อนไขการชำระหนี้
            </MKTypography>
            <MKTypography variant="h5" color="white" opacity={1} mt={1} mb={3}>
              มาตรการให้ความช่วยเหลือลูกหนี้ที่มีสถานะเป็นหนี้เสียที่มีภาระหนี้เงินต้นและดอกเบี้ยไม่เกิน
              1 แสนบาท
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <FormInfomation consentFlag={props.consentFlag} />
      </Card>
    </>
  );
}

FormRegister.defaultProps = {
  consentFlag: false,
};
FormRegister.propTypes = {
  consentFlag: PropTypes.bool,
};

export default FormRegister;
